import {OxygenError} from '../types.js';

export const DeploymentCancelQuery = `
mutation DeploymentCancel($deploymentId: ID!, $reason: String!) {
  deploymentCancel(id: $deploymentId, reason: $reason) {
    deployment {
      id
    }
    userErrors {
      message
    }
  }
}
`;

export interface DeploymentCancelQueryData {
  deploymentCancel: DeploymentCancelResponse;
}

export interface DeploymentCancelResponse {
  deployment: {
    id: string;
  };
  userErrors: OxygenError[];
}
